import React from 'react';
import { Link } from 'dva/router';
import Exception from '~/components/Exception';
import styles from './style.module.less';

export default () => (
  <Exception type="404" className={styles.exception} linkElement={Link} />
);
